/**
 * A linha de produto de uma empresa: Sysfar, Next ou Max.
 *
 * Sai da PRIMEIRA PALAVRA de `product_description` -- é assim que o dado chega
 * do ERP ("SYSFAR PDV 3.0", "NEXT GESTAO") e é assim que a consulta de cliente
 * MAX o monta ("MAX Ouro", "MAX Ilimitado").
 *
 * Vale a pena dizer por que isto virou função em 09/09/2026: a regra existia
 * escrita dentro do card do cliente selecionado, no TicketDetails. Quando o
 * mesmo rótulo passou a ser preciso no RESULTADO DA BUSCA, copiar seria criar
 * duas verdades -- e a que ficasse para trás mostraria um tipo diferente para a
 * mesma empresa em duas telas.
 *
 * A distinção só passou a valer alguma coisa quando o cliente MAX começou a ser
 * identificado (pelo CNPJ, já que ele não tem registro no ERP). Antes disso
 * praticamente tudo era Sysfar, e o rótulo não separava nada.
 */

/**
 * A primeira palavra de `product_description`, com a caixa arrumada.
 *
 * Devolve `null` quando não há o que mostrar -- e `null` é diferente de "-":
 * quem chama decide se esconde o chip ou desenha um traço.
 */
export const linhaDoProduto = (company) => {
    const descricao = String(company?.product_description || '').trim();

    // Uma guarda só: descrição vazia produz primeira palavra vazia (`''`), e é
    // o mesmo `!primeira` que resolve os dois casos.
    const primeira = descricao.split(/\s+/)[0];

    if (!primeira) return null;

    return primeira.charAt(0).toUpperCase() + primeira.slice(1).toLowerCase();
};
